/**
 * Authentication configuration
 */

/**
 * Generate a mock JWT token for development
 * This creates an unsigned JWT (signature is empty since we skip verification in dev mode)
 */
function generateMockJWT(): string {
  const header = {
    alg: 'RS256',
    typ: 'JWT',
  };

  const now = Math.floor(Date.now() / 1000);
  const oneYearFromNow = now + 365 * 24 * 60 * 60;

  const payload = {
    user_email: 'mock-agent@example.com',
    first_name: 'Mock Agent',
    entity_id: 'mock-entity-12345',
    property_address: '123 Mock Street, Mock City, MC 12345',
    created_at: now,
    exp: oneYearFromNow,
  };

  // Base64url encode header and payload
  const base64urlEncode = (obj: unknown) => {
    return btoa(JSON.stringify(obj)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
  };

  const encodedHeader = base64urlEncode(header);
  const encodedPayload = base64urlEncode(payload);

  // Return unsigned JWT (empty signature since we skip verification in dev mode)
  return `${encodedHeader}.${encodedPayload}.mock-signature-dev-only`;
}

/**
 * Mock JWT token for development
 *
 * This token is generated on-the-fly with current timestamps.
 *
 * Token payload:
 * {
 *   "user_email": "mock-agent@example.com",
 *   "first_name": "Mock Agent",
 *   "entity_id": "mock-entity-12345",
 *   "property_address": "123 Mock Street, Mock City, MC 12345",
 *   "created_at": <current timestamp>,
 *   "exp": <1 year from now> 
 * }
 */
export const MOCK_JWT_TOKEN = generateMockJWT();
export const JWT_SECRET_KEY = new TextEncoder().encode(import.meta.env.VITE_APP_JWT_SECRET_KEY || '');
